<template>
    <div>
        <v-container fluid hidden-sm-and-down pa-0>
            <v-jumbotron height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-sm-left>
                        <v-layout justify-center>
                            <v-flex xl10>
                                <v-toolbar-title class="display-2">
                                        Sobre nós
                                </v-toolbar-title>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xl10>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xs12 xl10>
                            <v-container fluid pa-0>
                                <v-layout>
                                    <v-flex xs4 text-xs-center v-for="item in itens" :key="item.img">
                                        <v-avatar size="175px" :tile="true">
                                            <img :src="getImgSVG(item.img)" :alt="item.titulo">
                                        </v-avatar>
                                        <v-divider class="my-2 transparent"></v-divider>
                                        <p class="display-1 font-weight-light">{{item.titulo}}</p>
                                        <p class="subheading font-weight-light pl-3 pr-3">{{item.texto}}</p>
                                        
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-jumbotron>

            <v-jumbotron height="auto" class="white">
                <v-toolbar flat class="transparent" style="margin-top: 3vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-sm-left>
                        <v-layout justify-center>
                            <v-flex xl10>
                                <v-toolbar-title class="display-2">
                                        Nossa equipe
                                </v-toolbar-title>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout justify-center>
                        <v-flex xl10>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container text-xs-center>
                    <v-layout justify-center>
                        <v-flex xs12 xl10>
                            <v-container fluid pa-0>
                                <v-layout>
                                    <v-flex xs2 v-for="fundador in fundadores" :key="fundador.nome">
                                        <v-avatar size="150px" class="elevation-5">
                                            <img :src="getImgSVG(fundador.img)" :alt="fundador.nome"> 
                                        </v-avatar>

                                        <v-divider class="my-2 transparent"></v-divider>
                                        <p class="title" style="margin: 5px;">{{fundador.nome}}</p>
                                        <p class="subheading">{{fundador.cargo}}</p>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-divider class="my-4 transparent"></v-divider>
            </v-jumbotron>
        </v-container>

        <v-container fluid hidden-md-and-up pa-0>
            <v-jumbotron height="auto">
                <v-toolbar flat class="transparent" style="margin-top: 2vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-xs-center>
                        <v-layout>
                            <v-flex xs12>
                                <v-toolbar-title class="display-1">
                                        Sobre nós
                                </v-toolbar-title>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout>
                        <v-flex>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12 text-xs-center v-for="item in itens" :key="item.img" mb-4>
                            <v-avatar size="150px" :tile="true">
                                <img :src="getImgSVG(item.img)" :alt="item.nome">
                            </v-avatar>
                            <v-divider class="my-2 transparent"></v-divider>
                            <p class="headline font-weight-light">{{item.titulo}}</p>
                            <p class="body-2 font-weight-light pl-3 pr-3">{{item.texto}}</p>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <v-jumbotron height="auto" class="white">
                <v-toolbar flat class="transparent" style="margin-top: 2vh;" >
                    <v-spacer></v-spacer>
                    <v-container text-xs-center>
                        <v-layout>
                            <v-flex xs12>
                                <v-toolbar-title class="display-1">
                                        Nossa equipe
                                </v-toolbar-title>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-container>
                    <v-layout>
                        <v-flex>
                            <v-divider class="my-0"></v-divider>    
                        </v-flex>
                    </v-layout>          
                </v-container>

                <v-container text-xs-center>
                    <v-layout row wrap>
                        <v-flex xs12 v-for="fundador in fundadores" :key="fundador.nome" mb-4>
                            <v-avatar size="150px" class="elevation-5">
                                <img :src="getImgSVG(fundador.img)" :alt="fundador.nome"> 
                            </v-avatar>

                            <v-divider class="my-2 transparent"></v-divider>
                            <p class="title" style="margin: 5px;">{{fundador.nome}}</p>
                            <p class="subheading">{{fundador.cargo}}</p>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>
        </v-container>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                itens: [
                    {
                        img: 'question', titulo: 'Quem somos?', texto: 
                        'Somos um grupo de estudantes de Engenharia da Computação, que por diversas vezes, não encontramos os produtos que desejávamos em nossa cidade para desenvolver nossos projetos'
                    },
                    {
                        img: 'logo-beco-svg', titulo: 'O que é o beco?', texto: 
                        'É uma loja desenvolvida por estudantes para qualquer pessoa que queira desenvolver seus próprios projetos de eletrônica e robótica, oferecendo os produtos necessários para que isso seja possível'
                    },
                    {
                        img: 'target', titulo: 'Nossos objetivos', texto: 
                        'Inicialmente, uma loja que ofereça aos estudantes de nossa região o necessário para desenvolverem seus projetos. Posteriormente, um E-Commerce inovador reconhecido nacionalmente'
                    }
                ],
                fundadores: [
                    {img:'luan', nome:'Luan Carlos', cargo:'Dev. Web Full-Stack'},
                    {img:'toin', nome:'Mateus Antonio', cargo:'Dev. Projetos / Maker'},
                    {img:'felipe', nome:'Felipe Nunes', cargo:'Dev. Mobile'}
                ]
            }
        },
        methods: {
            getImgSVG(path) {
                var images = require.context('../assets/', false, /\.svg$/)
                return images('./' + path + '.svg')
            }
        } 
    }
</script>




// WEBPACK FOOTER //
// src/components/about.vue